export default {"src":"/_next/static/media/InVar.080f3421.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};